
export const MIXPANEL_EVENTS = {
  PAGE_VIEW: "page_view",
  BOOKING_INITIATE: "book_a_visit_initiate",
  // SELECT_PET: "book_a_visit_select_pet",
  ADD_CALENDAR: "book_a_visit_add_calendar",
  NOTIFICATION_CLICK: "notification_click",
  NOTIFICATION_CTA_CLICK: "notification_cta_clicked",
  NOTI_MARK_READ: "notification_marked_read",
  ALL_NOTI_MARK_READ: "notification_mark_all_read",
  SHOW_PAST_NOTI: "notifications_show_past",
  EDIT_PROFILE: "user_edit_profile",
  VERIFY_MOB_EDIT: "user_edit_profile_verify_mobile",
  EDIT_RESEND_OTP: "user_edit_profile_verify_mobile_resend_otp",
  VERIFY_MOB_EDIT_SUCCESS: "user_edit_profile_verify_mobile_success",
  VERIFY_MOB_EDIT_FAILURE: "user_edit_profile_verify_mobile_failure",
  USER_EDIT_PROFILE_CLICK: "user_edit_profile_triggered",
  EDIT_PROFILE_SUCCESS: "user_edit_profile_success",
  EDIT_PROFILE_FAILURE: "user_edit_profile_failure",
  UPDATE_HOSPITAL: "user_update_hospital",
  UPDATE_HOSPITAL_PREVIEW: "user_update_hospital_preview",
  UPDATE_HOSPITAL_CLICK: "user_update_hospital_triggered",
  UPDATE_HOSPITAL_SUCCESS: "user_update_hospital_success",
  UPDATE_HOSPITAL_FAILURE: "user_update_hospital_failure",
  UPDATE_HOSPITAL_SUPPORT: "user_contacts_support",
  EDIT_PET_PAGE: "edit_pet_profile",
  EDIT_PET_CLICK: "edit_pet_profile_save_triggered",
  EDIT_PET_SUCCESS: "edit_pet_profile_save_success",
  EDIT_PET_FAILURE: "edit_pet_profile_save_failure",
  ADD_PAYEMENT: "user_payment_method_added",
  DEL_PAYEMENT: "user_payment_method_deleted",
  SET_DEF_PAYEMENT: "user_payment_set_card_default",
  SIGNUP_REQ_OTP: "user_signup_request_otp",
  SIGNUP_VER_MOB: "user_signup_verify_mobile",
  SIGNUP_VER_RESEND: "user_signup_verify_mobile_resend_otp",
  SIGNUP_OTP_VER_SUCCESS: "user_signup_verify_mobile_success",
  SIGNUP_OTP_VER_FAILURE: "user_signup_verify_mobile_failure",
  ADD_PERSONAL_DETAILS: "user_signup_personal_details",
  ADD_HOSPITAL: "user_signup_choose_hospital",
  SIGNUP_SUCCESS: "user_signup_success",
  SIGNUP_FAILURE: "user_signup_failure",
  SIGNIN_EMAIL_OTP: "user_signin_email_request_otp",
  SIGNIN_EMAIL_SUCCESS: "user_signin_email_success",
  SIGNIN_EMAIL_FAILURE: "user_signin_email_failure",
  SIGNIN_MOBILE_OTP: "user_signin_mobile_request_otp",
  SIGNIN_MOBILE_SUCCESS: "user_signin_mobile_success",
  SIGNIN_MOBILE_FAILURE: "user_signin_mobile_failure",
  LOGOUT: "user_signout",
  DELETE_ACCOUNT: "user_delete_profile",
  MEDICAL_RECORDS: "pet_medical_records",
  RABIES_CERTIFICATE: "pet_rabies_certificate",
  RESEND_OTP: "user_request_resend_otp",
  USER_CLICK_HOSPITAL_NAVIGATION: "user_navigate_hospital_location",
  VISIT_WELLNESS_PLAN: "user_visit_wellness_plan",
  CARE_TAB_CLICK: "user_visit_care_pet_profile",
  CARE_PORTAL: "user_visit_care_portal",
  CARE_SECTION: "user_visit_care_section",
  VISIT_DIAGNOSTIC: "user_visit_diagnostic",
  DIAGNOSTIC_ITEM_CLICK: "diagnostic_item_click",
  VISIT_VACCINATION: "user_visit_vaccination",
  VISIT_VACCINATION_CLICK: "vaccination_item_click",
  VISIT_PREVENTIVE: "user_visit_preventative",
  VISIT_PREVENTIVE_CLICK: "preventative_item_click",
  VISIT_PREVENTIVE_SAVE_CLICK: "user_self_report_save_triggered",
  ADD_SELF_REPORT_SUCCESS: "user_self_report_save_success",
  ADD_SELF_REPORT_FAILURE: "user_self_report_save_failure",
  VISIT_DENTAL: "user_visit_dental",
  VISIT_DENTAL_CLICK: "dental_item_click",
  VISIT_DENTAL_PROCEDURE: "dental_procedure / dentistry_procedure",
  VISIT_PRESCRIPTION: "user_visit_prescription",
  PAST_VISIT: "user_checks_past_visits",
  MY_ACCOUNT: "user_visit_my_account",
  USER_CLICK_SUBSCRIBE: "user_plan_billing_subscribe",
  VISIT_PLAN: "user_plan_and_billing",
  MANAGE_PLAN: "user_manage_plan",
  VISIT_PAYMENT: "user_payment_method",
  VISIT_CARD_DETAILS: "user_visit_specific_card_detail",
  REMOVE_PAYMENT_METHOD_CLICK: "user_remove_payment_method_click",
  REMOVE_CARD_DETAIL_SUCCESS: "user_remove_payment_method_success",
  REMOVE_CARD_DETAIL_FAILURE: "user_remove_payment_method_failure",
  ADD_CARD: "user_add_payment_method",
  ADD_CARD_CLICK: "user_add_payment_method_triggered",
  ADD_CARD_SUCCESS: "user_add_payment_method_success",
  ADD_CARD_FAILURE: "user_add_payment_method_failure",
  SET_CARD_DEFAULT: "user_set_default_card",
  PAYMENT_HISTORY: "user_payment_history",
  DOWNLOAD_INVOICE: "user_downloads_payment_invoice",
  USER_CLICK_PAST_PAYMENT: "user_past_payment_history",
  // Drop 2 phase 2 events
  USER_REQUEST_OTP: "user_signin_request_otp",
  USER_REQUEST_RESEND_OTP: "user_signin_request_otp",
  USER_SIGNIN_SUCCESS: "user_signin_success",
  USER_SIGNIN_FAILURE: "user_signin_failure",
  USER_FILL_PERSONAL_DETAILS: "user_signup_personal_details",
  USER_CHOOSE_LOCATION: "user_signup_choose_hospital",
  USER_SIGNUP_SUCCESS: "user_signup_success",
  USER_SIGNUP_FAILURE: "user_signup_failure",
  BOOK_A_VISIT: "book_a_visit_start",
  ADD_PET: "user_request_add_pet",
  ADD_PET_TRIGER: "user_add_pet_triggered",
  ADD_PET_SUCCESS: "user_add_pet_success",
  ADD_PET_FAILURE: "user_add_pet_failure",
  USER_CHECKS_PAST_VISIT: "user_checks_past_visits",
  BOOK_A_VISIT_SELECT_PET: "book_a_visit_select_pet",
  BOOK_A_VISIT_UNSELECT_PET: "book_a_visit_unselect_pet",
  FIND_AVAILABILITY: "book_a_visit_find_time",
  VISIT_REASON: "book_a_visit_reason",
  BOOK_A_VISIT_REASON_CATEGORY: "book_a_visit_reason_category",
  VISIT_REASON_SELECT: "book_a_visit_reason_select",
  BOOK_A_VISIT_CONFIRM: "book_a_visit_review_confirm",
  BOOK_A_VISIT_EXIT: "book_a_visit_exit_booking",
  BOOK_A_VISIT_RESUME: "book_a_visit_resume_booking",
  BOOK_A_VISIT_SUCCESS: "book_a_visit_confirm_success",
  BOOK_A_VISIT_FAILURE: "book_a_visit_confirm_failure",
  DAILY_CHECK_IN: "user_click_daily_checkin",
  USER_CLICK_UPCOMING_VISIT: "user_clicks_upcoming_visit",
  RESCHEDULE_VISIT: "user_reschedule_visit",
  CANCEL_VISIT: "user_cancel_visit",
  INTEREST_IN_WELLNESS_PLAN: "user_shows_interest_wellness_plan",
  USER_CLICK_PET_CARD: "user_click_pet_card",
  USER_VISIT_REASON_SELECTED: "book_a _visit_selected_overdue",
  USER_LEARN_MORE_WELLNESS_PLAN: "user_learn_more_wellness_plan",
  USER_WP_PET_SELECTION: "user_wp_pet_selection",
  VISIT_PAYMENT_CONFIRMATION_PAGE: "user_visit_payment_confirmation_page",
  BENEFIT_DETAILS_EXPANSION: "benefit_expansion - plan_details",
  WP_PURCHASE_TRIGGERED: "wp_purchase_triggered",
  WP_PURCHASE_SUCCESS: "wp_purchase_success",
  WP_PURCHASE_FAILURE: "wp_purchase_failure",
  USER_CLOSES_DASHBOARD_UPSELL_CARD: "user_closes_dashboard_upsell_card",
  WP_UPSELL_DISMISSED: "wp_upsell_dismissed",
  USER_CLICKS_EXPLORE_PLAN: "user_clicks_explore_plan",
  USER_CLICKS_MANAGE_PLAN: "user_clicks_manage_plan",
  USER_CLICKS_REVIEW_NEW_TOTALCARE_PLANS: "user_clicks_review_new_totalcare_plans",
  USER_CLICK_CANCEL_RENEWAL: "user_click_cancel_renewal",
  USER_CANCEL_RENEWAL_TRIGGERED: "user_cancel_renewal_triggered",
  RENEWAL_CANCELLATION_SUCCESS: "user_renewal_cancellation_success",
  RENEWAL_CANCELLATION_FAILURE: "user_renewal_cancellation_failure",
  USER_RE_ENABLE_RENEW: "user_re-enable_renew",
  BACK_BUTTON_CLICK_PLAN_DETAILS: "back_button_click - plan_details",
  BACK_BUTTON_CLICK_CONFIRM_PAY: "back_button_click - confirm_pay",
  USER_CLOSES_CANCEL_RENEWAL: "user_closes_cancel_renewal",
  // Retire pet events
  RETIRE_PET_PROFILE: "retire_pet_profile",
  SELECT_REASON_RETIRE_PET: "select_reason_retire_pet",
  EDIT_REASON_RETIRE_PET_PROFILE: "edit_reason_retire_pet_profile",
  EXIT_RETIRE_PET_FLOW: "exit_retire_pet_flow",
  RETIRE_PET_PROFILE_TRIGGERED: "retire_pet_profile_triggered",
  RETIRE_PET_PROFILE_SUCCESS: "retire_pet_profile_success",
  RETIRE_PET_PROFILE_FAILURE: "retire_pet_profile_failure",
  // REVIEW APPOINTMENT EVENTS
  STAR_RATING_SELECTED: "star_rating_selected",
  REVIEW_PAGE_CLOSED: "review_page_closed",
  STAR_RATING_SUBMITTED: "star_rating_submitted",
  NPS_RATING_SELECTED: "nps_rating_selected",
  NPS_RATING_SUBMITTED: "nps_rating_submitted",
  QUESTION1_RESPONSE_SUBMITTED: "question1_response_submitted",
  QUESTION2_RESPONSE_SUBMITTED: "question2_response_submitted",
  GOOGLE_REVIEW_PROMPT_TRIGGERED: "google_review_prompt_triggered",
  USER_CLICKS_POST_REVIEW_TO_GOOGLE: "user_clicks_post_review_to_google",
  SEE_FULL_REVIEW_BUTTON_CLICKED: "see_full_review_button_clicked",
  VISIT_PAST_REVIEW: "visit_past_review",
  // UPDATE PAYMENT EVENTS
  USER_UPDATE_PAYMENT_METHOD_TRIGGERED: "user_update_payment_method_triggered",
  USER_UPDATE_PAYMENT_METHOD_SUCCESS: "user_update_payment_method_success",
  USER_UPDATE_PAYMENT_METHOD_FAILURE: "user_update_payment_method_failure",

  // PROMO CODE EVENTS
  PROMOCODE_VALIDATION_TRIGGERED: "promocode_validation_triggered",
  PROMOCODE_VALIDATION_SUCCESS: "promocode_validation_success",
  PROMOCODE_VALIDATION_FAILED: "promocode_validation_failed",
  PROMOCODE_REMOVED: "promocode_removed",

  // OVERDUE INVOICE EVENTS
  VIEW_OVERDUE_INVOICE_CLICKED: "view_overdue_invoice_clicked",
  PAY_NOW_CLICKED: "pay_now_clicked",
  CANCELED_WP_USERS_CONTACT_HOSPITAL: "canceled_wp_users_contact_hospital",
  OVERDUE_POP_UP_CLOSED: "overdue_pop_up_closed",
  DASHBOARD_OVERDUE_CARD_SHOWN: "dashboard_overdue_card_shown",
  DELINQUENCY_MODAL_SHOWN: "delinquency_modal_shown",
  DELINQUENCY_BOOKING_BLOCKED: "delinquency_booking_blocked",

  // ScratchPay Delinquency (generic, derive specifics in Mixpanel from props)
  DELINQUENCY_SURFACE_SHOWN: "delinquency_surface_shown",
  DELINQUENCY_CTA_CLICKED: "delinquency_cta_clicked",
  DELINQUENCY_NOTIFICATION_CLICKED: "delinquency_notification_clicked",

  // DROP OFF EVENTS
  USER_SWITCH_TO_IN_ROOM_VISIT: "user_switch_to_in_room_visit",
  USER_CONFIRM_DROP_OFF_APPOINTMENT: "user_confirm_drop_off_appointment",
  USER_SWITCH_TO_DROP_OFF: "user_switch_to_drop_off",
  DROP_OFF_ADD_CALENDAR: "drop_off_add_calendar",
  // DUPLICATE ACCOUNT EVENTS
  DASHBOARD_DUPLICATE_ACCOUNT_CARD_SHOWN: "dashboard_duplicate_account_card_shown",
  CONTACT_HOSPITAL_TRIGGERED: "contact_hospital_triggered",
  // ASSIGN PAYMENT EVENTS
  USER_ASSIGN_PAYMENT_METHOD_CONFIRM: "user_assign_payment_method_confirm",
  USER_ASSIGN_PAYMENT_METHOD_SUCCESS: "user_assign_payment_method_success",
  USER_ASSIGN_PAYMENT_METHOD_FAILURE: "user_assign_payment_method_failure",
  USER_SKIP_PAYMENT_METHOD_UPDATE: "user_skip_payment_method_update",
  // EXPRESS VISIT EVENTS
  EXPRESS_SERVICE_SELECTED: "express_service_selected",
  EXPRESS_SERVICE_SELECT_PET: "express_service_select_pet",
  EXPRESS_SERVICE_SELECT_REASON_CATEGORY: "express_service_select_reason_category",
  EXPRESS_SERVICE_FIND_TIME: "express_service_find_time",
  EXPRESS_SERVICE_REVIEW_CONFIRM: "express_service_review_confirm",
  USER_CLICK_EDIT_DETAILS: "user_click_edit_details",
  EXPRESS_SERVICE_BOOKING_CONFIRM: "express_service_booking_confirm",
  EXPRESS_SERVICE_ADD_CALENDAR: "express_service_add_calendar",
  // New User Mobile Signup
  USER_SIGNUP_ADD_MOBILE_NUMBER: "user_signup_add_mobile_number",
  USER_REQUEST_RESEND_OTP_MOBILE_VERIFICATION: "user_request_resend_otp_mobile_verification",
  USER_MOBILE_VERIFICATION_SUCCESS: "user_mobile_verification_success",
  USER_MOBILE_VERIFICATION_FAILURE: "user_mobile_verification_failure",
  // update payment method
  USER_CLICK_UPDATE_PAYMENT_FROM_POP_UP: "user_click_update_payment_from_pop_up",
  // Wellness alerts
  USER_CLICK_GOT_IT_IN_POPUP: "user_click_got_it_in_popup",
  USER_CLICK_PURCHASE_PLAN_POPUP: "user_click_purchase_plan_popup",
  USER_CLICK_RENEW_PLAN_POPUP: "user_click_renew_plan_popup",
  USER_CLICKS_PAST_PLANS: "user_clicks_past_plans",
  USER_LANDS_ON_DASHBOARD: "user_lands_on_dashboard",
  PLAN_END_POP_UP_DISMISSED: "plan_end_pop_up_dismissed",
  RENEWAL_UNSUCCESSFUL_POP_UP_DISMISSED: "renewal_unsuccessful_pop_up_dismissed",
  PAYMENT_OVERDUE_DISMISSED: "payment_overdue_dismissed",
  RENEWAL_SUCCESSFUL_POP_UP_DISMISSED: "renewal_successful_pop_up_dismissed",
  WP_VALUE_POP_UP_DISMISSED: "wp_value_pop_up_dismissed",
  PLAN_CANCELLED_POP_UP_DISMISSED: "plan_cancelled_pop_up_dismissed",
  USER_CLICK_UPDATE_PAYMENT_FROM_DASHBOARD: "user_click_update_payment_from_dashboard",
  // Customer Referrals
  USER_CLICK_REFER_A_FRIEND: "user_click_refer_a_friend",
  REFERRAL_MODAL_COPY_LINK: "referral_modal_copy_link",
  SEND_EMAIL_INVITE_TRIGGERED: "send_email_invite_triggered",
  SEND_EMAIL_INVITE_SUCCESS: "send_email_invite_success",
  SEND_EMAIL_INVITE_FAILURE: "send_email_invite_failure",
  SHARE_VIA_SMS_CLICKED: "share_via_sms_clicked",
  QUICK_SHARE_REFERRAL_MODAL_SHOWN: "quick_share_referral_modal_shown",
  UPSELL_MODAL_SHOWN: "upsell_modal_shown",
  MAYBE_LATER_CLICKED: "maybe_later_clicked",
  INVITE_FRIENDS_CLICKED: "invite_friends_clicked",
  QUICK_SHARE_REFERRAL_MODAL_DISMISSED: "quick_share_referral_modal_dismissed",
  UPSELL_MODAL_DISMISSED: "upsell_modal_dissmissed",
  LEARN_MORE_CLICKED: "learn_more_clicked",
  // Upfront Payment
  PAYMENT_ISSUE_PAY_INVOICE_MODAL_SHOWN: "payment_issue_pay_invoice_modal_shown",
  PAYMENT_ISSUE_PAY_INVOICE_CLICKED: "payment_issue_pay_invoice_clicked",
  PAYMENT_ISSUE_PAY_INVOICE_MODAL_DISMISSED: "payment_issue_pay_invoice_modal_dismissed",
  PAYMENT_PENDING_MODAL_SHOWN: "payment_pending_modal_shown",
  PAYMENT_PENDING_GOT_IT_CLICKED: "payment_pending_got_it_clicked",
  PAYMENT_PENDING_MODAL_DISMISSED: "payment_pending_modal_dismissed",
  // New Annual Wellness Purchase Flow Events
  USER_WP_PET_BIRTHDAY_INPUT: "user_wp_pet_birthday_input",
  USER_WP_PLAN_SELECTION: "user_wp_plan_selection",
  USER_WP_PLAN_TOGGLE: "user_wp_plan_toggle",
  USER_WP_SUBSCRIPTION_TYPE_SELECTION: "user_wp_subscription_type_selection",
  // Renewal Flow Events
  USER_WP_RENEWAL_SUBSCRIPTION_TYPE_SELECTION: "user_wp_renewal_subscription_type_selection",
  WP_RENEWAL_PURCHASE_TRIGGERED: "wp_renewal_purchase_triggered",
  WP_RENEWAL_SAVE_PREFERENCE: "wp_renewal_save_preference",
  WP_RENEWAL_SAVE_PREFERENCE_ERROR: "wp_renewal_save_preference_error",
  GOODPET_TO_TOTALCARE_TRANSITION_SUCCESS: "goodpet_to_totalcare_transition_success",
  GOODPET_TO_TOTALCARE_TRANSITION_FAILURE: "goodpet_to_totalcare_transition_failure",
  UPSELL_RENEWAL_MODAL_SHOWN: "upsell_renewal_modal_shown",
  DASHBOARD_RENEWAL_CARD_SHOWN: "dashboard_renewal_card_shown",
  CANCEL_UPCOMING_PLAN_RENEWAL_MODAL_SHOWN: "cancel_upcoming_plan_renewal_modal_shown",
  CANCEL_UPCOMING_PLAN_RENEWAL_SUCCESS_MODAL_SHOWN: "cancel_upcoming_plan_renewal_success_modal_shown",
  MOVE_YOUR_PLAN_TO_TOTALCARE_BANNER_SHOWN: "move_your_plan_to_totalcare_banner_shown",
  NEW_WELLNESS_EXPERIENCE_BANNER_SHOWN: "new_wellness_experience_banner_shown",
  WELLNESS_PLAN_SELECT_PET_CONTAINER_SHOWN: "wellness_plan_select_pet_container_shown",
  // ScratchPay Events
  SCRATCHPAY_ELIGIBLE: "scratchpay_eligible",
  SCRATCHPAY_NOT_ELIGIBLE: "scratchpay_not_eligible",
  SCRATCHPAY_ELIGIBILITY_ERROR: "scratchpay_eligibility_error",
  SCRATCHPAY_INFO_MODAL_VIEWED: "scratchpay_info_modal_viewed",
  SCRATCHPAY_MONTHLY_SELECTED: "scratchpay_monthly_selected",
  SCRATCHPAY_PURCHASE_INITIATED: "scratchpay_purchase_initiated",
  SCRATCHPAY_PAYMENT_ERROR: "scratchpay_payment_error",
  SCRATCHPAY_REDIRECT_TO_EXTERNAL: "scratchpay_redirect_to_external",
  SCRATCHPAY_STATUS_POLLING_STARTED: "scratchpay_status_polling_started",
  SCRATCHPAY_STATUS_APPROVED: "scratchpay_status_approved",
  SCRATCHPAY_STATUS_DENIED: "scratchpay_status_denied",
  SCRATCHPAY_STATUS_ERROR: "scratchpay_status_error",
  SCRATCHPAY_STATUS_EXPIRED: "scratchpay_status_expired",
  SCRATCHPAY_STATUS_CANCELLED: "scratchpay_status_cancelled",
  SCRATCHPAY_PLAN_CREATED_SUCCESS: "scratchpay_plan_created_success",
  SCRATCHPAY_PURCHASE_SUCCESS_MODAL_VIEWED: "scratchpay_purchase_success_modal_viewed",
  SCRATCHPAY_SUCCESS_EXPLORE_PLAN_CLICKED: "scratchpay_success_explore_plan_clicked",
  SCRATCHPAY_SUCCESS_MODAL_DISMISSED: "scratchpay_success_modal_dismissed",
  // ScratchPay Renewal Pending Events
  SCRATCHPAY_RENEWAL_PENDING_MODAL_VIEWED: "scratchpay_renewal_pending_modal_viewed",
  SCRATCHPAY_RENEWAL_PENDING_GOT_IT_CLICKED: "scratchpay_renewal_pending_got_it_clicked",
  SCRATCHPAY_RENEWAL_PENDING_CARD_SHOWN: "scratchpay_renewal_pending_card_shown",
  SCRATCHPAY_RENEWAL_APPLY_NOW_CLICKED: "scratchpay_renewal_apply_now_clicked",
  SCRATCHPAY_RENEWAL_APPLY_NOW_MISSING_PET_ID: "scratchpay_renewal_apply_now_missing_pet_id",
  // URGENT VISIT EVENTS
  URGENT_VISIT_INITIATE: "urgent_visit_initiate",
  URGENT_VISIT_SELECT_PET: "urgent_visit_select_pet",
  URGENT_VISIT_SELECT_TIME: "urgent_visit_select_time",
  URGENT_VISIT_SELECT_REASON: "urgent_visit_select_reason",
  URGENT_VISIT_REVIEW_CONFIRM: "urgent_visit_review_confirm",
  URGENT_VISIT_BOOKING_SUCCESS: "urgent_visit_booking_success",
  URGENT_VISIT_BOOKING_FAILURE: "urgent_visit_booking_failure",
  URGENT_VISIT_ADD_CALENDAR: "urgent_visit_add_calendar",
  URGENT_VISIT_ACKNOWLEDGEMENT: "urgent_visit_acknowledgement",
  URGENT_VISIT_EXIT: "urgent_visit_exit",
  // Pharmacy/Prescription Events
  PHARMACY_TAB_VIEWED: "pharmacy_tab_viewed",
  PHARMACY_PRESCRIPTIONS_LOADED: "pharmacy_prescriptions_loaded",
  PHARMACY_PRESCRIPTION_VIEWED: "pharmacy_prescription_viewed",
  PHARMACY_PRESCRIPTION_ORDER_CLICKED: "pharmacy_prescription_order_clicked",
  PHARMACY_PRESCRIPTION_RENEW_CLICKED: "pharmacy_prescription_renew_clicked",
  // Customer Support Events
  CUSTOMER_SUPPORT_MODAL_OPENED: "customer_support_modal_opened",
  CUSTOMER_SUPPORT_EXPLORE_SUPPORT_CENTER: "customer_support_explore_support_center",
  CUSTOMER_SUPPORT_SUBMIT_TICKET_INITIATE: "customer_support_submit_ticket_initiate",
  CUSTOMER_SUPPORT_TICKET_SUBMIT_SUCCESS: "customer_support_ticket_submit_success",
  CUSTOMER_SUPPORT_TICKET_SUBMIT_FAILURE: "customer_support_ticket_submit_failure",
  CUSTOMER_SUPPORT_MODAL_CLOSED: "customer_support_modal_closed",
  // TotalCare Prequalification Events
  PREQUAL_BANNER_DISMISSED: "prequal_banner_dismissed",
  PREQUAL_STARTED: "prequal_started",
  PREQUAL_PET_SELECT_SHOWN: "prequal_pet_select_shown",
  PREQUAL_PET_SELECTED: "prequal_pet_selected",
  PREQUAL_ELIGIBILITY_CHECK_SUBMITTED: "prequal_eligibility_check_submitted",
  PREQUAL_LEGAL_LINK_OPENED: "prequal_legal_link_opened",
  PREQUAL_CONSENT_VIEWED: "prequal_consent_viewed",
  PREQUAL_ELIGIBILITY_RESULT: "prequal_eligibility_result",
  PREQUAL_STATUS_RECOGNIZED: "prequal_status_recognized",
  PREQUAL_ERROR_SHOWN: "prequal_error_shown",
  PREQUAL_SEE_PLANS: "prequal_see_plans",
  PREQUAL_BILLING_OPTION_SELECTED: "prequal_billing_option_selected",
  PREQUAL_PURCHASE_FUNNEL_ENTERED: "prequal_purchase_funnel_entered",
  PREQUAL_INTERCEPTOR_SHOWN: "prequal_interceptor_shown",
  PREQUAL_INTERCEPTOR_CONTINUE: "prequal_interceptor_continue",
  PREQUAL_INTERCEPTOR_SKIP: "prequal_interceptor_skip",
};
